import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, ALLOWED, errMsg } from "./prodApi";
import { PButton, PInput, PField } from "./ProdUi";

export default function ProdLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await axios.post(`${API}/auth/login`, { email, password, remember_me: true });
      if (!ALLOWED.includes(r.data.user?.role)) {
        toast.error("Account non abilitato alla Produzione");
        return;
      }
      await onLogin(r.data.token);
    } catch (err) {
      toast.error(errMsg(err, "Credenziali non valide"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex flex-col md:flex-row font-['IBM_Plex_Sans']">
      <div className="w-full md:w-[42%] flex flex-col justify-center px-6 md:px-14 py-12">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-blue-400">Giotto Carni · Reparto</p>
        <p className="font-['Chivo'] font-black text-5xl md:text-6xl text-white tracking-tighter leading-none mt-2">
          PRODU<span className="text-blue-500">ZIONE</span>
        </p>
        <p className="text-slate-400 text-sm mt-4">Rese di sezionamento · Costi e margini · Lavorazioni reali</p>
        <form onSubmit={submit} className="space-y-5 mt-10" data-testid="prod-login-form">
          <PField label="Email operatore">
            <PInput type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="operatore@giotto.it" autoComplete="username" required data-testid="prod-login-email" />
          </PField>
          <PField label="Password">
            <PInput type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" required data-testid="prod-login-password" />
          </PField>
          <PButton type="submit" variant="primary" size="lg" className="w-full" disabled={loading} data-testid="prod-login-submit-btn">
            {loading ? "Accesso..." : "Entra in Produzione"}
          </PButton>
        </form>
        <p className="text-slate-600 text-xs mt-8">Accesso riservato agli operatori di produzione e agli amministratori.</p>
      </div>
      <div className="hidden md:flex flex-1 bg-slate-900 border-l border-slate-800 items-center justify-center p-14">
        <div className="max-w-md space-y-6">
          {[["INPUT", "10 pistole · 1.000 kg · 9,50 €/kg"], ["RICETTA", "Disosso completo · resa vendibile 75%"], ["COSTO", "Medio · Coefficienti · Valore di vendita"], ["RISULTATO", "Fatturato · Margine · €/kg · €/ora"]].map(([k, v], i) => (
            <div key={k} className="flex items-center gap-4">
              <span className="w-12 h-12 rounded-xl bg-blue-600/20 border border-blue-500/40 text-blue-300 font-['Chivo'] font-black flex items-center justify-center">{i + 1}</span>
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{k}</p>
                <p className="text-white font-semibold">{v}</p>
              </div>
            </div>
          ))}
          <p className="font-['Chivo'] font-black text-2xl text-white pt-4">Nessun kg sparisce. Nessun costo sparisce.</p>
        </div>
      </div>
    </div>
  );
}
